import { css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

import { textEllipsisStyles } from "styles/common";
import { StackingContextLevel } from "styles/stacking-context-level";
import { withVar } from "themes/helpers";

export const cannedTextStyles = css(
  {
    color: withVar(DesignToken.ContentBasicSecondary),
  },
  textEllipsisStyles
);

export const pickerZIndexStyles = css({
  zIndex: StackingContextLevel.Dropdown,
});
